import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {OperationalContactModel} from "../../models/operational-contact.model";

require('./bringoz-operational-contacts-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-operational-contacts-table-row',
  templateUrl: './bringoz-operational-contacts-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozOperationalContactsTableRowComponent {
  @Input() operationalContact: OperationalContactModel;
}
